import { Button, Grid, Tooltip } from '@design-systems/canvas-ui'
import Icon, { PlusIcon, DownloadIcon } from '@design-systems/react-icons'
import { UserContext } from 'App/UserContext'
import { useContext } from 'react'
import { Link, useNavigate } from 'react-router-dom'

const TeamHeaderButtons = () => {
  const navigate = useNavigate()
  const { isAdmin } = useContext(UserContext)

  return (
    <Grid.Container>
      {isAdmin && (
        <Grid.Item>
          <Tooltip location="top-right" content="Download to Excel">
            <Button
              data-test="download-excel"
              as={Link}
              variant="secondary"
              aria-label="Download to Excel"
              target="_blank"
              to="/api/pdf/api/export/users"
            >
              <Icon svg={DownloadIcon} /> Download user list
            </Button>
          </Tooltip>
        </Grid.Item>
      )}
      <Grid.Item>
        <Button variant="primary" onClick={() => navigate('/teams/create')}>
          <Icon svg={PlusIcon} /> Create team
        </Button>
      </Grid.Item>
    </Grid.Container>
  )
}

export default TeamHeaderButtons
